import { useState } from 'react';
import { Bell, HelpCircle, RefreshCw, Menu, Sun, Moon } from 'lucide-react';

function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem('portal_theme') === 'dark'; } catch { return false; }
  });
  function toggle() {
    const next = !dark;
    setDark(next);
    try {
      if (next) {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('portal_theme', 'dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
        localStorage.setItem('portal_theme', 'light');
      }
    } catch { /* ignore storage errors */ }
  }
  return (
    <button
      className="btn btn-secondary btn-sm"
      style={{ padding: '7px 8px' }}
      onClick={toggle}
      title={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label="Toggle colour theme"
    >
      {dark ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}

const PAGE_META = {
  dashboard:  { title: 'Dashboard',            sub: 'Real-time overview of your Damovo Hosting environment' },
  numbers:    { title: 'Number Inventory',      sub: 'Manage your Voxbone DID numbers and assignments' },
  routing:    { title: 'Routing Rules',         sub: 'Configure call routing from PSTN to UC / CC platforms' },
  sbc:        { title: 'SBC Management',        sub: 'AudioCodes Session Border Controller health and config' },
  platforms:  { title: 'UC / CC Platforms',     sub: 'Connected unified communications and contact centre platforms' },
  analytics:  { title: 'Analytics',             sub: 'Call volume, quality, and usage trends' },
  alerts:     { title: 'Alerts',                sub: 'System notifications and action items' },
  voxbone:    { title: 'Number Routing',        sub: 'Manage DID routing between primary and alternative SIP URIs' },
  bwrouting:  { title: 'BW Number Routing',     sub: 'Configure Bandwidth DID SIP destinations (demo mode)' },
  admin:      { title: 'Admin Portal',          sub: 'Manage customers, assign numbers, and sync DID inventory' },
  settings:   { title: 'Settings',              sub: 'Customer account, billing, and API credentials' },
  security:   { title: 'Security & Compliance', sub: 'TLS/SRTP status, audit logs, and compliance reports' },
  callquality:{ title: 'Teams Call Quality',    sub: 'Microsoft Teams call quality metrics' },
  users:      { title: 'User Directory',        sub: 'Manage portal users and permissions' },
  sites:      { title: 'Sites',                 sub: 'Physical and logical site management' },
};

export default function Topbar({ page, onRefresh, user, onNav, alertCount = 0, onMenuToggle }) {
  const meta     = PAGE_META[page] || { title: page, sub: '' };
  const initials = (user?.name || 'U').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="hamburger-btn" onClick={onMenuToggle} aria-label="Open navigation">
          <Menu size={22} />
        </button>
        <div>
          <div className="page-title">{meta.title}</div>
          <div className="page-sub">{meta.sub}</div>
        </div>
      </div>
      <div className="topbar-right">
        <button className="btn btn-secondary btn-sm topbar-refresh" onClick={onRefresh}>
          <RefreshCw size={13} /> Refresh
        </button>
        <div className="tooltip-wrap" style={{ position: 'relative' }}>
          <button className="btn btn-secondary btn-sm" style={{ padding: '7px 8px' }} onClick={() => onNav?.('alerts')}>
            <Bell size={14} />
          </button>
          {alertCount > 0 && <span className="notif-badge">{alertCount}</span>}
          <span className="tooltip">{alertCount > 0 ? `${alertCount} active alert${alertCount !== 1 ? 's' : ''}` : 'No active alerts'}</span>
        </div>
        <button className="btn btn-secondary btn-sm topbar-help" style={{ padding: '7px 8px' }}>
          <HelpCircle size={14} />
        </button>
        <ThemeToggle />
        <div className="avatar">{initials}</div>
      </div>
    </header>
  );
}
